import { render, staticRenderFns } from "./FileAttachment.vue?vue&type=template&id=7ac1bf4a&"
import script from "./FileAttachment.vue?vue&type=script&lang=js&"
export * from "./FileAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ac1bf4a')) {
      api.createRecord('7ac1bf4a', component.options)
    } else {
      api.reload('7ac1bf4a', component.options)
    }
    module.hot.accept("./FileAttachment.vue?vue&type=template&id=7ac1bf4a&", function () {
      api.rerender('7ac1bf4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/meeting-agendas/items/FileAttachment.vue"
export default component.exports